// src/pages/menu-items/ContinentalMenuItems.jsx
import React from 'react';
import MenuItemList from '../MenuItemList';

const ContinentalMenuItems = () => {
  return <MenuItemList locationKey="continental" />;
};

export default ContinentalMenuItems;